/* src/app/shared/modals/support-chat/support-chat.component.scss */
.content-card.fixed {
  padding-right: 0;
  padding-bottom: 0;
}
.content-card.fixed .card-container {
  padding-bottom: 0;
  padding-right: 0;
  margin-left: -16px;
  position: relative;
}
#tawk_68639f2689d0b51907b13c63 {
  width: 100%;
  height: 100%;
}
#spinner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/*# sourceMappingURL=support-chat.component.css.map */
